"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropClinicalProgramsFilterFilterNameEnum = void 0;
exports.PropClinicalProgramsFilterFilterNameEnum = {
    All: 'All',
    WomensHealth: "Women's Health",
    HealthyWeight: 'Healthy Weight',
    FamilyParentsSiblings: 'Family (Parents, siblings)',
    AnxietyWorryStress: 'Anxiety (Worry, Stress)',
    ReproductiveHealth: 'Reproductive Health',
    MensHealth: "Men's Health",
    Work: 'Work',
    Military: 'Military',
    PhysicalHealth: 'Physical Health',
    Lgbtq: 'LGBTQ+',
    Therapy: 'Therapy',
    College: 'College',
    Teenagers: 'Teenagers',
};
//# sourceMappingURL=prop-clinical-programs-filter.js.map